import React from 'react';
import { useRoutes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Policy from './pages/Policy';
import Schedule from './pages/Schedule';
import Safety from './pages/Safety';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';

const AppRoutes: React.FC = () => {
  const routes = useRoutes([
    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: 'policy', element: <Policy /> },
        { path: 'schedule', element: <Schedule /> },
        { path: 'safety', element: <Safety /> },
        { path: 'contact', element: <Contact /> },
        { path: 'gallery', element: <Gallery /> },
      ]
    }
  ]);

  return routes;
};

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
